/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Signin_FootnoteInputs */

const en_signin_footnote = /** @type {(inputs: Signin_FootnoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Built by the team behind Bystep.`)
};

const id_signin_footnote = /** @type {(inputs: Signin_FootnoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dibuat oleh tim yang sama dengan Bystep.`)
};

/**
* | output |
* | --- |
* | "Built by the team behind Bystep." |
*
* @param {Signin_FootnoteInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const signin_footnote = /** @type {((inputs?: Signin_FootnoteInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Signin_FootnoteInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_signin_footnote(inputs)
	return en_signin_footnote(inputs)
});